import React, { Component } from 'react'
import axios from 'axios';
import { Notifications } from '../common/notification';
import Select from 'react-select';
import { BILLING_CREATED, RATEDECK_UPLOAD_FILE } from '../../config/rest_endpoints';
import { getUser } from '../../actions/session';


export class RateAddDeckForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            User: getUser(),
            charges: '',
            rates: '',
            selectedCharges: '',
            selectedtype: '',
            optionsConnectCharges: [
                { value: '6s', label: '6s' },
                { value: '12s', label: '12s' },
                { value: '18s', label: '18s' },
                { value: '24s', label: '24s' },
                { value: '30s', label: '30s' },
                { value: '60s', label: '60s' },
            ],
            optionsAccountType: [
                { value: 'Postpay', label: 'Postpay' },
                { value: 'Prepay', label: 'Prepay' }
            ],
            roundMethod: [
                { value: '*up', label: 'Up' },
                { value: '*down', label: 'Down' }
            ],
            selectRoundMethod: '',
            roundDigits: [
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' }
            ],
            selectRoundDigits: '',
            subsequent: [
                { value: '6s', label: '6s' },
                { value: '12s', label: '12s' },
                { value: '18s', label: '18s' },
                { value: '30s', label: '30s' },
                { value: '60s', label: '60s' },
            ],
            subsequentSelect: '',
            billList: [],
            selectFile: null,
            msg: '',
            isSpin:false
        }
        this.handleSelectAccount = this.handleSelectAccount.bind(this)
        this.handleSelectCharges = this.handleSelectCharges.bind(this)
        this.onHandleChange = this.onHandleChange.bind(this)
        this.onSubmitBill = this.onSubmitBill.bind(this)
        this.handleRoundDigitsSelect = this.handleRoundDigitsSelect.bind(this)
        this.handleRoundMethodSelect = this.handleRoundMethodSelect.bind(this)
        this.handleSubsequentSelect = this.handleSubsequentSelect.bind(this)
        this.handleFileUpload = this.handleFileUpload.bind(this)
    }

    onHandleChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    handleFileUpload(e) {
        this.setState({ selectFile: e.target.files[0] }, () => {
            console.log('file :>> ', this.state.selectFile);
        })
    }

    handleSelectCharges(selectedCharges) {
        this.setState({ selectedCharges });
        console.log(`Option selectedCharges:`, selectedCharges);
    };

    handleSelectAccount(selectedtype) {
        this.setState({ selectedtype });
        console.log(`Option selectedtype:`, selectedtype);
    };

    handleSubsequentSelect(subsequentSelect) {
        this.setState({ subsequentSelect })
    }

    handleRoundMethodSelect(selectRoundMethod) {
        this.setState({ selectRoundMethod })
    }

    handleRoundDigitsSelect(selectRoundDigits) {
        this.setState({ selectRoundDigits })
    }

    onSubmitBill() {
        const { User, userId, charges, rates, selectedCharges, subsequentSelect, selectRoundMethod, selectRoundDigits, selectFile, isSpin } = this.state
        var payload = {
            "connectFee": parseInt(charges),
            "ratePerMin": parseInt(rates),
            "initialInc": selectedCharges.value,
            "subsequentInc": subsequentSelect.value,
            "roundingMethod": selectRoundMethod.value,
            "roundingDigits": selectRoundDigits.value
        }

        const data = new FormData()
        data.append('file', selectFile)
        data.append('request', JSON.stringify(payload))
        var headers = { 'Authorization': "Bearer " + User.token }
        this.setState({isSpin:true})
        axios.post(RATEDECK_UPLOAD_FILE, data, { headers }).then(res => {
            if (res) {
                console.log('res :', res);
                this.setState({
                    msg: res.data.message,
                    isSpin:false
                })
                Notifications.notify(this.state.msg, "Created", "success")
                this.props.listing()
                this.props.close()
            }
        }).catch(err => {
            var msessage = err.response.data.message
            console.log(`msessage`, msessage)
            Notifications.notify(msessage, "Failed", "error")
            this.setState({isSpin:false})
        })
    }

    render() {
        const { subsequentSelect, subsequent, selectRoundDigits, roundDigits, selectRoundMethod, roundMethod, charges,isSpin, rates, selectedOption, optionsConnectCharges, optionsAccountType, selectedCharges, selectedtype, billList, isGetting, isError } = this.state

        return (
            <div>
                <div className="row">
                <div className="col-md-6">
                        <div className="form-group">
                            <label>Initial Increment</label>
                            <Select
                                value={selectedCharges}
                                onChange={this.handleSelectCharges}
                                options={optionsConnectCharges}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Subsequent Increment</label>
                            <Select
                                value={subsequentSelect}
                                onChange={this.handleSubsequentSelect}
                                options={subsequent}
                            />
                        </div>
                    </div>
                   
                   
                </div>
                <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                            <label>Rounding Method</label>
                            <Select
                                value={selectRoundMethod}
                                onChange={this.handleRoundMethodSelect}
                                options={roundMethod}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Rounding Digits</label>
                            <Select
                                value={selectRoundDigits}
                                onChange={this.handleRoundDigitsSelect}
                                options={roundDigits}
                            />
                        </div>
                    </div>
                   
                   
                </div>
                
                <div className="row">
                <div className="col-md-6">
                        <div className="form-group">
                            <label>Connect Charges</label>
                            <input type="number" className="form-control" name="charges" value={charges} onChange={this.onHandleChange} placeholder="Enter charges" />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <label>File Upload:</label>
                            <div className="uniform-uploader"><input type="file" accept=".csv" onChange={this.handleFileUpload} className="form-input-styled" data-fouc="" /><span className="filename" style={{ userSelect: 'none' }}>{this.state.selectFile === null ? 'no file is selected' : this.state.selectFile.name}</span><span className="action btn bg-success" style={{ userSelect: 'none' }}>Choose File</span></div>
                            <span className="form-text text-muted">Accepted formats: csv. Max file size 2Mb</span>
                        </div>
                    </div>
                  
                </div>
                <div className="row ml-auto">
                    <div className="col-md-6 ml-auto">
                        <button type="submit" className="btn bg-success float-right" disabled={isSpin ? true :false} onClick={this.onSubmitBill} >Add Ratedeck {isSpin ? <i class="icon-spinner4 spinner ml-2"></i> : <i class="icon-coins ml-2"></i>}</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default RateAddDeckForm
